module.exports = __webpack_public_path__ + "img/addVideoWhite.01291821.svg";